import Home from "../pages/home";
import { Route, Switch, BrowserRouter as Router} from "react-router-dom";
/*
import Product from "../pages/product"
import Cart from "../pages/cart"
import Account from "../pages/account"
import Checkout from "../pages/checkout";
import PayPal from "../pages/PayPal";
import { Route, Switch, BrowserRouter as Router} from "react-router-dom";
import Facturation from "../pages/Facturation";
import Success from "../pages/success";
import Cancelled from "../pages/cancelled";
import Brand from "../pages/brand";
import Categorie from "../pages/categorie";
import Payment from "../pages/payment";
import Profile from "../pages/Profile";
import Dashboard from "../pages/user/dashboard";
import Securite from "../pages/user/securite";
import UserOrders from "../pages/user/userorders";
import userDetails from "../pages/user/userdetails";

// ADMIN
import adminLog from "../pages/admin/adminlog";
import Items from "../pages/admin/items";
import AddItem from "../pages/admin/additem";
import UpdateItem from "../pages/admin/updateItem";
import Orders from "../pages/admin/allOrdes";
import ThisOrders from "../pages/admin/thisOrder";
//import Login from "../pages/Login";



const routes = [
    {path: "/", name: "home", component: Home},
    {path: "/product/:id", name: "product", component: Product},
    {path: "/account", name: "account", component: Account},
    {path: "/checkout/", name: "checkout", component: Checkout},
    {path: "/cart/", name: "cart", component: Cart},
    {path: "/PayPal", name: "paypal", component: PayPal},
    //{path: "/login", name: "login", component: Login},
];

*/
const Routes = () =>{
    return(
        <Router>
            <Switch>
                <Route exact path="/" name="home" component={Home} />
              
               
            </Switch>
        </Router>
    )
}


export default Routes;